import { axios } from '@/services/axios';

export const getRegistrars = (companyId) => {
    const endpoint = `/TRSRegistrars/${companyId}`;
    const res = axios.get(endpoint);
    return res;
};
